import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router';

import PageLoader from '../loaders/pageLoader';

const DemoPage = lazy(() => import('../../components/pages/userAccount/requestDemo'));

export const demoRoutes = {
	path: '/request-demo',
	element: <Outlet />,
	children: [
		{
			index: true,
			element: (
				<Suspense fallback={<PageLoader />}>
					<DemoPage />
				</Suspense>
			),
		},
	],
};
